import {IBizChallenge, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {AChallenge} from "@/views/editor/service/challenge/challenge";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export class Praise extends AChallenge implements IBizChallenge {
    readonly subs: CheckboxOptionType[] = [];
    readonly opt: { [key: string]: unknown }

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as { [key: string]: unknown }
    }

    resetMeta(): IBusiness {
        console.log('Praise reset meta');
        return this;
    }
}